/**
 * Format an ISO date/datetime string locale-aware (DD.MM.YYYY for de, MM/DD/YYYY for en, etc.).
 *
 * @param {string|null} value
 * @param {{ time?: boolean, locale?: string }} options
 * @returns {string|null}
 */
/**
 * Format an ISO date string to month and year only (e.g. "Oktober 2026").
 *
 * @param {string|null} value
 * @param {{ locale?: string }} options
 * @returns {string|null}
 */
export function formatMonth(value, { locale = navigator.language } = {}) {
    if (!value) return null;

    const date = new Date(value.replace(" ", "T"));

    return new Intl.DateTimeFormat(locale, { year: "2-digit", month: "short" }).format(date);
}

export function formatDate(value, { time = false, locale = navigator.language } = {}) {
    if (!value) return null;

    const date = new Date(value.replace(" ", "T"));
    const opts = { year: "numeric", month: "2-digit", day: "2-digit" };

    if (time) {
        opts.hour = "2-digit";
        opts.minute = "2-digit";
    }

    return new Intl.DateTimeFormat(locale, opts).format(date);
}
